/**
 * Import a script that cannot be imported as a module due to for example CORS
 * Will prevent the same script being loaded multiple times, and handle a queue of callbacks whilst it is being loaded
 */
const scripts = [];

export default (src, callback, attr = {}) => {
	let i = scripts.findIndex(item => item.src === src);

	// load the script
	if (i === -1) {

		// create script object
		const script = document.createElement("script");
		attr = Object.assign({
			src: src,
			async: true
		}, attr);
		Object.entries(attr).forEach(([key, item]) => script[key] = item);

		// setup load callback
		i = scripts.length;
		scripts.push({src, callbacks: callback ? [callback] : [], loaded: false});
		script.addEventListener("load", () => {
			scripts[i].callbacks.forEach(item => item());
			scripts[i].loaded = true;
		}, {once: true});

		// attach the script
		document.body.append(script);

	// add callback
	} else if (!scripts[i].loaded && callback) {
		scripts[i].callbacks.push(callback);
	} else {
		callback();
	}
};
